
/*
 Tooltip
 Copyright (C) Federico Zivolo 2018
 Distributed under the MIT License (license terms are at http://opensource.org/licenses/MIT).
 */
(function (e, t) {
    'object' == typeof exports && 'undefined' != typeof module ? module.exports = t() : 'function' == typeof define && define.amd ? define(t) : e.Popper = t()
})(this, function () {
    'use strict';

    function e(e) {
        return e && '[object Function]' === {}.toString.call(e)
    }

    function t(e, t) {
        if (1 !== e.nodeType) return [];
        var o = getComputedStyle(e, null);
        return t ? o[t] : o
    }

    function o(e) {
        return 'HTML' === e.nodeName ? e : e.parentNode || e.host
    }

    function n(e) {
        if (!e) return document.body;
        switch (e.nodeName) {
            case'HTML':
            case'BODY':
                return e.ownerDocument.body;
            case'#document':
                return e.body;
        }
        var i = t(e), r = i.overflow, p = i.overflowX, s = i.overflowY;
        return /(auto|scroll|overlay)/.test(r + s + p) ? e : n(o(e))
    }

    function r(e) {
        return 11 === e ? re : 10 === e ? pe : re || pe
    }

    function p(e) {
        if (!e) return document.documentElement;
        for (var o = r(10) ? document.body : null, n = e.offsetParent; n === o && e.nextElementSibling;) n = (e = e.nextElementSibling).offsetParent;
        var i = n && n.nodeName;
        return i && 'BODY' !== i && 'HTML' !== i ? -1 !== ['TD', 'TABLE'].indexOf(n.nodeName) && 'static' === t(n, 'position') ? p(n) : n : e ? e.ownerDocument.documentElement : document.documentElement
    }

    function s(e) {
        var t = e.nodeName;
        return 'BODY' !== t && ('HTML' === t || p(e.firstElementChild) === e)
    }

    function d(e) {
        return null === e.parentNode ? e : d(e.parentNode)
    }

    function a(e, t) {
        if (!e || !e.nodeType || !t || !t.nodeType) return document.documentElement;
        var o = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING, n = o ? e : t, i = o ? t : e,
            r = document.createRange();
        r.setStart(n, 0), r.setEnd(i, 0);
        var l = r.commonAncestorContainer;
        if (e !== l && t !== l || n.contains(i)) return s(l) ? l : p(l);
        var f = d(e);
        return f.host ? a(f.host, t) : a(e, d(t).host)
    }

    function l(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 'top',
            o = 'top' === t ? 'scrollTop' : 'scrollLeft', n = e.nodeName;
        if ('BODY' === n || 'HTML' === n) {
            var i = e.ownerDocument.documentElement, r = e.ownerDocument.scrollingElement || i;
            return r[o]
        }
        return e[o]
    }

    function f(e, t) {
        var o = 2 < arguments.length && void 0 !== arguments[2] && arguments[2], n = l(t, 'top'), i = l(t, 'left'),
            r = o ? -1 : 1;
        return e.top += n * r, e.bottom += n * r, e.left += i * r, e.right += i * r, e
    }

    function m(e, t) {
        var o = 'x' === t ? 'Left' : 'Top', n = 'Left' == o ? 'Right' : 'Bottom';
        return parseFloat(e['border' + o + 'Width'], 10) + parseFloat(e['border' + n + 'Width'], 10)
    }

    function h(e, t, o, n) {
        return $(t['offset' + e], t['scroll' + e], o['client' + e], o['offset' + e], o['scroll' + e], r(10) ? o['offset' + e] + n['margin' + ('Height' === e ? 'Top' : 'Left')] + n['margin' + ('Height' === e ? 'Bottom' : 'Right')] : 0)
    }

    function c() {
        var e = document.body, t = document.documentElement, o = r(10) && getComputedStyle(t);
        return {height: h('Height', e, t, o), width: h('Width', e, t, o)}
    }

    function g(e) {
        return le({}, e, {right: e.left + e.width, bottom: e.top + e.height})
    }

    function u(e) {
        var o = {};
        try {
            if (r(10)) {
                o = e.getBoundingClientRect();
                var n = l(e, 'top'), i = l(e, 'left');
                o.top += n, o.left += i, o.bottom += n, o.right += i
            } else o = e.getBoundingClientRect()
        } catch (t) {
        }
        var p = {left: o.left, top: o.top, width: o.right - o.left, height: o.bottom - o.top},
            s = 'HTML' === e.nodeName ? c() : {}, d = s.width || e.clientWidth || p.right - p.left,
            a = s.height || e.clientHeight || p.bottom - p.top, f = e.offsetWidth - d, h = e.offsetHeight - a;
        if (f || h) {
            var u = t(e);
            f -= m(u, 'x'), h -= m(u, 'y'), p.width -= f, p.height -= h
        }
        return g(p)
    }

    function b(e, o) {
        var i = 2 < arguments.length && void 0 !== arguments[2] && arguments[2], p = r(10), s = 'HTML' === o.nodeName,
            d = u(e), a = u(o), l = n(e), m = t(o), h = parseFloat(m.borderTopWidth, 10),
            c = parseFloat(m.borderLeftWidth, 10);
        i && 'HTML' === o.nodeName && (a.top = $(a.top, 0), a.left = $(a.left, 0));
        var b = g({top: d.top - a.top - h, left: d.left - a.left - c, width: d.width, height: d.height});
        if (b.marginTop = 0, b.marginLeft = 0, !p && s) {
            var y = parseFloat(m.marginTop, 10), w = parseFloat(m.marginLeft, 10);
            b.top -= h - y, b.bottom -= h - y, b.left -= c - w, b.right -= c - w, b.marginTop = y, b.marginLeft = w
        }
        return (p && !i ? o.contains(l) : o === l && 'BODY' !== l.nodeName) && (b = f(b, o)), b
    }

    function y(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1], o = e.ownerDocument.documentElement,
            n = b(e, o), i = $(o.clientWidth, window.innerWidth || 0), r = $(o.clientHeight, window.innerHeight || 0),
            p = t ? 0 : l(o), s = t ? 0 : l(o, 'left'),
            d = {top: p - n.top + n.marginTop, left: s - n.left + n.marginLeft, width: i, height: r};
        return g(d)
    }

    function w(e) {
        var n = e.nodeName;
        return 'BODY' === n || 'HTML' === n ? !1 : 'fixed' === t(e, 'position') || w(o(e))
    }

    function E(e) {
        if (!e || !e.parentElement || r()) return document.documentElement;
        for (var o = e.parentElement; o && 'none' === t(o, 'transform');) o = o.parentElement;
        return o || document.documentElement
    }

    function v(e, t, i, r) {
        var p = 4 < arguments.length && void 0 !== arguments[4] && arguments[4], s = {top: 0, left: 0},
            d = p ? E(e) : a(e, t);
        if ('viewport' === r) s = y(d, p); else {
            var l;
            'scrollParent' === r ? (l = n(o(t)), 'BODY' === l.nodeName && (l = e.ownerDocument.documentElement)) : 'window' === r ? l = e.ownerDocument.documentElement : l = r;
            var f = b(l, d, p);
            if ('HTML' === l.nodeName && !w(d)) {
                var m = c(), h = m.height, g = m.width;
                s.top += f.top - f.marginTop, s.bottom = h + f.top, s.left += f.left - f.marginLeft, s.right = g + f.left
            } else s = f
        }
        return s.left += i, s.top += i, s.right -= i, s.bottom -= i, s
    }

    function x(e) {
        var t = e.width, o = e.height;
        return t * o
    }

    function O(e, t, o, n, i) {
        var r = 5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === e.indexOf('auto')) return e;
        var p = v(o, n, r, i), s = {
            top: {width: p.width, height: t.top - p.top},
            right: {width: p.right - t.right, height: p.height},
            bottom: {width: p.width, height: p.bottom - t.bottom},
            left: {width: t.left - p.left, height: p.height}
        }, d = Object.keys(s).map(function (e) {
            return le({key: e}, s[e], {area: x(s[e])})
        }).sort(function (e, t) {
            return t.area - e.area
        }), a = d.filter(function (e) {
            var t = e.width, n = e.height;
            return t >= o.clientWidth && n >= o.clientHeight
        }), l = 0 < a.length ? a[0].key : d[0].key, f = e.split('-')[1];
        return l + (f ? '-' + f : '')
    }

    function L(e, t, o) {
        var n = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null, i = n ? E(t) : a(t, o);
        return b(o, i, n)
    }

    function S(e) {
        var t = getComputedStyle(e), o = parseFloat(t.marginTop) + parseFloat(t.marginBottom),
            n = parseFloat(t.marginLeft) + parseFloat(t.marginRight),
            i = {width: e.offsetWidth + n, height: e.offsetHeight + o};
        return i
    }

    function T(e) {
        var t = {left: 'right', right: 'left', bottom: 'top', top: 'bottom'};
        return e.replace(/left|right|bottom|top/g, function (e) {
            return t[e]
        })
    }

    function C(e, t, o) {
        o = o.split('-')[0];
        var n = S(e), i = {width: n.width, height: n.height}, r = -1 !== ['right', 'left'].indexOf(o),
            p = r ? 'top' : 'left', s = r ? 'left' : 'top', d = r ? 'height' : 'width', a = r ? 'width' : 'height';
        return i[p] = t[p] + t[d] / 2 - n[d] / 2, i[s] = o === s ? t[s] - n[a] : t[T(s)], i
    }

    function D(e, t) {
        return Array.prototype.find ? e.find(t) : e.filter(t)[0]
    }

    function N(e, t, o) {
        if (Array.prototype.findIndex) return e.findIndex(function (e) {
            return e[t] === o
        });
        var n = D(e, function (e) {
            return e[t] === o
        });
        return e.indexOf(n)
    }

    function P(t, o, n) {
        var i = void 0 === n ? t : t.slice(0, N(t, 'name', n));
        return i.forEach(function (t) {
            t['function'] && console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
            var n = t['function'] || t.fn;
            t.enabled && e(n) && (o.offsets.popper = g(o.offsets.popper), o.offsets.reference = g(o.offsets.reference), o = n(o, t))
        }), o
    }

    function k() {
        if (!this.state.isDestroyed) {
            var e = {instance: this, styles: {}, arrowStyles: {}, attributes: {}, flipped: !1, offsets: {}};
            e.offsets.reference = L(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = O(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = C(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute', e = P(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e))
        }
    }

    function W(e, t) {
        return e.some(function (e) {
            var o = e.name, n = e.enabled;
            return n && o === t
        })
    }

    function B(e) {
        for (var t = [!1, 'ms', 'Webkit', 'Moz', 'O'], o = e.charAt(0).toUpperCase() + e.slice(1), n = 0; n < t.length; n++) {
            var i = t[n], r = i ? '' + i + o : e;
            if ('undefined' != typeof document.body.style[r]) return r
        }
        return null
    }

    function H() {
        return this.state.isDestroyed = !0, W(this.modifiers, 'applyStyle') && (this.popper.removeAttribute('x-placement'), this.popper.style.position = '', this.popper.style.top = '', this.popper.style.left = '', this.popper.style.right = '', this.popper.style.bottom = '', this.popper.style.willChange = '', this.popper.style[B('transform')] = ''), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this
    }

    function A(e) {
        var t = e.ownerDocument;
        return t ? t.defaultView : window
    }

    function M(e, t, o, i) {
        var r = 'BODY' === e.nodeName, p = r ? e.ownerDocument.defaultView : e;
        p.addEventListener(t, o, {passive: !0}), r || M(n(p.parentNode), t, o, i), i.push(p)
    }

    function I(e, t, o, i) {
        o.updateBound = i, A(e).addEventListener('resize', o.updateBound, {passive: !0});
        var r = n(e);
        return M(r, 'scroll', o.updateBound, o.scrollParents), o.scrollElement = r, o.eventsEnabled = !0, o
    }

    function F() {
        this.state.eventsEnabled || (this.state = I(this.reference, this.options, this.state, this.scheduleUpdate))
    }

    function R(e, t) {
        return A(e).removeEventListener('resize', t.updateBound), t.scrollParents.forEach(function (e) {
            e.removeEventListener('scroll', t.updateBound)
        }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t
    }

    function U() {
        this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = R(this.reference, this.state))
    }

    function Y(e) {
        return '' !== e && !isNaN(parseFloat(e)) && isFinite(e)
    }

    function j(e, t) {
        Object.keys(t).forEach(function (o) {
            var n = '';
            -1 !== ['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(o) && Y(t[o]) && (n = 'px'), e.style[o] = t[o] + n
        })
    }

    function K(e, t) {
        Object.keys(t).forEach(function (o) {
            var n = t[o];
            !1 === n ? e.removeAttribute(o) : e.setAttribute(o, t[o])
        })
    }

    function q(e, t, o) {
        var n = D(e, function (e) {
            var o = e.name;
            return o === t
        }), i = !!n && e.some(function (e) {
            return e.name === o && e.enabled && e.order < n.order
        });
        if (!i) {
            var r = '`' + t + '`';
            console.warn('`' + o + '`' + ' modifier is required by ' + r + ' modifier in order to work, be sure to include it before ' + r + '!')
        }
        return i
    }

    function G(e) {
        return 'end' === e ? 'start' : 'start' === e ? 'end' : e
    }

    function z(e) {
        var t = 1 < arguments.length && void 0 !== arguments[1] && arguments[1], o = me.indexOf(e),
            n = me.slice(o + 1).concat(me.slice(0, o));
        return t ? n.reverse() : n
    }

    function V(e, t, o, n) {
        var i = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), r = +i[1], p = i[2];
        if (!r) return e;
        if (0 === p.indexOf('%')) {
            var s;
            switch (p) {
                case'%p':
                    s = o;
                    break;
                case'%':
                case'%r':
                default:
                    s = n;
            }
            var d = g(s);
            return d[t] / 100 * r
        }
        if ('vh' === p || 'vw' === p) {
            var a;
            return a = 'vh' === p ? $(document.documentElement.clientHeight, window.innerHeight || 0) : $(document.documentElement.clientWidth, window.innerWidth || 0), a / 100 * r
        }
        return r
    }

    function _(e, t, o, n) {
        var i = [0, 0], r = -1 !== ['right', 'left'].indexOf(n), p = e.split(/(\+|\-)/).map(function (e) {
            return e.trim()
        }), s = p.indexOf(D(p, function (e) {
            return -1 !== e.search(/,|\s/)
        }));
        p[s] && -1 === p[s].indexOf(',') && console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
        var d = /\s*,\s*|\s+/,
            a = -1 === s ? [p] : [p.slice(0, s).concat([p[s].split(d)[0]]), [p[s].split(d)[1]].concat(p.slice(s + 1))];
        return a = a.map(function (e, n) {
            var i = (1 === n ? !r : r) ? 'height' : 'width', p = !1;
            return e.reduce(function (e, t) {
                return '' === e[e.length - 1] && -1 !== ['+', '-'].indexOf(t) ? (e[e.length - 1] = t, p = !0, e) : p ? (e[e.length - 1] += t, p = !1, e) : e.concat(t)
            }, []).map(function (e) {
                return V(e, i, t, o)
            })
        }), a.forEach(function (e, t) {
            e.forEach(function (o, n) {
                Y(o) && (i[t] += o * ('-' === e[n - 1] ? -1 : 1))
            })
        }), i
    }

    function X(e, t) {
        var o, n = t.offset, i = e.placement, r = e.offsets, p = r.popper, s = r.reference, d = i.split('-')[0];
        return o = Y(+n) ? [+n, 0] : _(n, p, s, d), 'left' === d ? (p.top += o[0], p.left -= o[1]) : 'right' === d ? (p.top += o[0], p.left += o[1]) : 'top' === d ? (p.left += o[0], p.top -= o[1]) : 'bottom' === d && (p.left += o[0], p.top += o[1]), e.popper = p, e
    }

    for (var J = Math.min, Q = Math.round, Z = Math.floor, $ = Math.max, ee = 'undefined' != typeof window && 'undefined' != typeof document, te = ['Edge', 'Trident', 'Firefox'], oe = 0, ne = 0; ne < te.length; ne += 1) if (ee && 0 <= navigator.userAgent.indexOf(te[ne])) {
        oe = 1;
        break
    }
    var i = ee && window.Promise, ie = i ? function (e) {
            var t = !1;
            return function () {
                t || (t = !0, window.Promise.resolve().then(function () {
                    t = !1, e()
                }))
            }
        } : function (e) {
            var t = !1;
            return function () {
                t || (t = !0, setTimeout(function () {
                    t = !1, e()
                }, oe))
            }
        }, re = ee && !!(window.MSInputMethodContext && document.documentMode),
        pe = ee && /MSIE 10/.test(navigator.userAgent), se = function (e, t) {
            if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function')
        }, de = function () {
            function e(e, t) {
                for (var o, n = 0; n < t.length; n++) o = t[n], o.enumerable = o.enumerable || !1, o.configurable = !0, 'value' in o && (o.writable = !0), Object.defineProperty(e, o.key, o)
            }

            return function (t, o, n) {
                return o && e(t.prototype, o), n && e(t, n), t
            }
        }(), ae = function (e, t, o) {
            return t in e ? Object.defineProperty(e, t, {
                value: o,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = o, e
        }, le = Object.assign || function (e) {
            for (var t, o = 1; o < arguments.length; o++) for (var n in t = arguments[o], t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            return e
        },
        fe = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'],
        me = fe.slice(3), he = {FLIP: 'flip', CLOCKWISE: 'clockwise', COUNTERCLOCKWISE: 'counterclockwise'},
        ce = function () {
            function t(o, n) {
                var i = this, r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
                se(this, t), this.scheduleUpdate = function () {
                    return requestAnimationFrame(i.update)
                }, this.update = ie(this.update.bind(this)), this.options = le({}, t.Defaults, r), this.state = {
                    isDestroyed: !1,
                    isCreated: !1,
                    scrollParents: []
                }, this.reference = o && o.jquery ? o[0] : o, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(le({}, t.Defaults.modifiers, r.modifiers)).forEach(function (e) {
                    i.options.modifiers[e] = le({}, t.Defaults.modifiers[e] || {}, r.modifiers ? r.modifiers[e] : {})
                }), this.modifiers = Object.keys(this.options.modifiers).map(function (e) {
                    return le({name: e}, i.options.modifiers[e])
                }).sort(function (e, t) {
                    return e.order - t.order
                }), this.modifiers.forEach(function (t) {
                    t.enabled && e(t.onLoad) && t.onLoad(i.reference, i.popper, i.options, t, i.state)
                }), this.update();
                var p = this.options.eventsEnabled;
                p && this.enableEventListeners(), this.state.eventsEnabled = p
            }

            return de(t, [{
                key: 'update', value: function () {
                    return k.call(this)
                }
            }, {
                key: 'destroy', value: function () {
                    return H.call(this)
                }
            }, {
                key: 'enableEventListeners', value: function () {
                    return F.call(this)
                }
            }, {
                key: 'disableEventListeners', value: function () {
                    return U.call(this)
                }
            }]), t
        }();
    return ce.Utils = ('undefined' == typeof window ? global : window).PopperUtils, ce.placements = fe, ce.Defaults = {
        placement: 'bottom',
        positionFixed: !1,
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function () {
        },
        onUpdate: function () {
        },
        modifiers: {
            shift: {
                order: 100, enabled: !0, fn: function (e) {
                    var t = e.placement, o = t.split('-')[0], n = t.split('-')[1];
                    if (n) {
                        var i = e.offsets, r = i.reference, p = i.popper, s = -1 !== ['bottom', 'top'].indexOf(o),
                            d = s ? 'left' : 'top', a = s ? 'width' : 'height',
                            l = {start: ae({}, d, r[d]), end: ae({}, d, r[d] + r[a] - p[a])};
                        e.offsets.popper = le({}, p, l[n])
                    }
                    return e
                }
            },
            offset: {order: 200, enabled: !0, fn: X, offset: 0},
            preventOverflow: {
                order: 300, enabled: !0, fn: function (e, t) {
                    var o = t.boundariesElement || p(e.instance.popper);
                    e.instance.reference === o && (o = p(o));
                    var n = B('transform'), i = e.instance.popper.style, r = i.top, s = i.left, d = i[n];
                    i.top = '', i.left = '', i[n] = '';
                    var a = v(e.instance.popper, e.instance.reference, t.padding, o, e.positionFixed);
                    i.top = r, i.left = s, i[n] = d, t.boundaries = a;
                    var l = t.priority, f = e.offsets.popper, m = {
                        primary: function (e) {
                            var o = f[e];
                            return f[e] < a[e] && !t.escapeWithReference && (o = $(f[e], a[e])), ae({}, e, o)
                        }, secondary: function (e) {
                            var o = 'right' === e ? 'left' : 'top', n = f[o];
                            return f[e] > a[e] && !t.escapeWithReference && (n = J(f[o], a[e] - ('right' === e ? f.width : f.height))), ae({}, o, n)
                        }
                    };
                    return l.forEach(function (e) {
                        var t = -1 === ['left', 'top'].indexOf(e) ? 'secondary' : 'primary';
                        f = le({}, f, m[t](e))
                    }), e.offsets.popper = f, e
                }, priority: ['left', 'right', 'top', 'bottom'], padding: 5, boundariesElement: 'scrollParent'
            },
            keepTogether: {
                order: 400, enabled: !0, fn: function (e) {
                    var t = e.offsets, o = t.popper, n = t.reference, i = e.placement.split('-')[0], r = Z,
                        p = -1 !== ['top', 'bottom'].indexOf(i), s = p ? 'right' : 'bottom', d = p ? 'left' : 'top',
                        a = p ? 'width' : 'height';
                    return o[s] < r(n[d]) && (e.offsets.popper[d] = r(n[d]) - o[a]), o[d] > r(n[s]) && (e.offsets.popper[d] = r(n[s])), e
                }
            },
            arrow: {
                order: 500, enabled: !0, fn: function (e, o) {
                    var n;
                    if (!q(e.instance.modifiers, 'arrow', 'keepTogether')) return e;
                    var i = o.element;
                    if ('string' == typeof i) {
                        if (i = e.instance.popper.querySelector(i), !i) return e;
                    } else if (!e.instance.popper.contains(i)) return console.warn('WARNING: `arrow.element` must be child of its popper element!'), e;
                    var r = e.placement.split('-')[0], p = e.offsets, s = p.popper, d = p.reference,
                        a = -1 !== ['left', 'right'].indexOf(r), l = a ? 'height' : 'width', f = a ? 'Top' : 'Left',
                        m = f.toLowerCase(), h = a ? 'left' : 'top', c = a ? 'bottom' : 'right', u = S(i)[l];
                    d[c] - u < s[m] && (e.offsets.popper[m] -= s[m] - (d[c] - u)), d[m] + u > s[c] && (e.offsets.popper[m] += d[m] + u - s[c]), e.offsets.popper = g(e.offsets.popper);
                    var b = d[m] + d[l] / 2 - u / 2, y = t(e.instance.popper), w = parseFloat(y['margin' + f], 10),
                        E = parseFloat(y['border' + f + 'Width'], 10), v = b - e.offsets.popper[m] - w - E;
                    return v = $(J(s[l] - u, v), 0), e.arrowElement = i, e.offsets.arrow = (n = {}, ae(n, m, Q(v)), ae(n, h, ''), n), e
                }, element: '[x-arrow]'
            },
            flip: {
                order: 600, enabled: !0, fn: function (e, t) {
                    if (W(e.instance.modifiers, 'inner')) return e;
                    if (e.flipped && e.placement === e.originalPlacement) return e;
                    var o = v(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed),
                        n = e.placement.split('-')[0], i = T(n), r = e.placement.split('-')[1] || '', p = [];
                    switch (t.behavior) {
                        case he.FLIP:
                            p = [n, i];
                            break;
                        case he.CLOCKWISE:
                            p = z(n);
                            break;
                        case he.COUNTERCLOCKWISE:
                            p = z(n, !0);
                            break;
                        default:
                            p = t.behavior;
                    }
                    return p.forEach(function (s, d) {
                        if (n !== s || p.length === d + 1) return e;
                        n = e.placement.split('-')[0], i = T(n);
                        var a = e.offsets.popper, l = e.offsets.reference, f = Z,
                            m = 'left' === n && f(a.right) > f(l.left) || 'right' === n && f(a.left) < f(l.right) || 'top' === n && f(a.bottom) > f(l.top) || 'bottom' === n && f(a.top) < f(l.bottom),
                            h = f(a.left) < f(o.left), c = f(a.right) > f(o.right), g = f(a.top) < f(o.top),
                            u = f(a.bottom) > f(o.bottom),
                            b = 'left' === n && h || 'right' === n && c || 'top' === n && g || 'bottom' === n && u,
                            y = -1 !== ['top', 'bottom'].indexOf(n),
                            w = !!t.flipVariations && (y && 'start' === r && h || y && 'end' === r && c || !y && 'start' === r && g || !y && 'end' === r && u);
                        (m || b || w) && (e.flipped = !0, (m || b) && (n = p[d + 1]), w && (r = G(r)), e.placement = n + (r ? '-' + r : ''), e.offsets.popper = le({}, e.offsets.popper, C(e.instance.popper, e.offsets.reference, e.placement)), e = P(e.instance.modifiers, e, 'flip'))
                    }), e
                }, behavior: 'flip', padding: 5, boundariesElement: 'viewport'
            },
            inner: {
                order: 700, enabled: !1, fn: function (e) {
                    var t = e.placement, o = t.split('-')[0], n = e.offsets, i = n.popper, r = n.reference,
                        p = -1 !== ['left', 'right'].indexOf(o), s = -1 === ['top', 'left'].indexOf(o);
                    return i[p ? 'left' : 'top'] = r[o] - (s ? i[p ? 'width' : 'height'] : 0), e.placement = T(t), e.offsets.popper = g(i), e
                }
            },
            hide: {
                order: 800, enabled: !0, fn: function (e) {
                    if (!q(e.instance.modifiers, 'hide', 'preventOverflow')) return e;
                    var t = e.offsets.reference, o = D(e.instance.modifiers, function (e) {
                        return 'preventOverflow' === e.name
                    }).boundaries;
                    if (t.bottom < o.top || t.left > o.right || t.top > o.bottom || t.right < o.left) {
                        if (!0 === e.hide) return e;
                        e.hide = !0, e.attributes['x-out-of-boundaries'] = ''
                    } else {
                        if (!1 === e.hide) return e;
                        e.hide = !1, e.attributes['x-out-of-boundaries'] = !1
                    }
                    return e
                }
            },
            computeStyle: {
                order: 850, enabled: !0, fn: function (e, t) {
                    var o = t.x, n = t.y, i = e.offsets.popper, r = D(e.instance.modifiers, function (e) {
                        return 'applyStyle' === e.name
                    }).gpuAcceleration;
                    void 0 !== r && console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
                    var s, d, a = void 0 === r ? t.gpuAcceleration : r, l = p(e.instance.popper), f = u(l),
                        m = {position: i.position},
                        h = {left: Z(i.left), top: Q(i.top), bottom: Q(i.bottom), right: Z(i.right)},
                        c = 'bottom' === o ? 'top' : 'bottom', g = 'right' === n ? 'left' : 'right', b = B('transform');
                    if (d = 'bottom' == c ? -f.height + h.bottom : h.top, s = 'right' == g ? -f.width + h.right : h.left, a && b) m[b] = 'translate3d(' + s + 'px, ' + d + 'px, 0)', m[c] = 0, m[g] = 0, m.willChange = 'transform'; else {
                        var y = 'bottom' == c ? -1 : 1, w = 'right' == g ? -1 : 1;
                        m[c] = d * y, m[g] = s * w, m.willChange = c + ', ' + g
                    }
                    var E = {"x-placement": e.placement};
                    return e.attributes = le({}, E, e.attributes), e.styles = le({}, m, e.styles), e.arrowStyles = le({}, e.offsets.arrow, e.arrowStyles), e
                }, gpuAcceleration: !0, x: 'bottom', y: 'right'
            },
            applyStyle: {
                order: 900, enabled: !0, fn: function (e) {
                    return j(e.instance.popper, e.styles), K(e.instance.popper, e.attributes), e.arrowElement && Object.keys(e.arrowStyles).length && j(e.arrowElement, e.arrowStyles), e
                }, onLoad: function (e, t, o, n, i) {
                    var r = L(i, t, e, o.positionFixed),
                        p = O(o.placement, r, t, e, o.modifiers.flip.boundariesElement, o.modifiers.flip.padding);
                    return t.setAttribute('x-placement', p), j(t, {position: o.positionFixed ? 'fixed' : 'absolute'}), o
                }, gpuAcceleration: void 0
            }
        }
    }, ce
});
//# sourceMappingURL=popper.min.js.map


/*!
 * Lightbox v2.10.0
 * by Lokesh Dhakar
 *
 * More info:
 * http://lokeshdhakar.com/projects/lightbox2/
 *
 * Copyright 2007, 2018 Lokesh Dhakar
 * Released under the MIT license
 * https://github.com/lokesh/lightbox2/blob/master/LICENSE
 *
 * @preserve
 */
!function (a, b) {
    "function" == typeof define && define.amd ? define(["jquery"], b) : "object" == typeof exports ? module.exports = b(require("jquery")) : a.lightbox = b(a.jQuery)
}(this, function (a) {
    function b(b) {
        this.album = [], this.currentImageIndex = void 0, this.init(), this.options = a.extend({}, this.constructor.defaults), this.option(b)
    }

    return b.defaults = {
        albumLabel: "Image %1 of %2",
        alwaysShowNavOnTouchDevices: !1,
        fadeDuration: 600,
        fitImagesInViewport: !0,
        imageFadeDuration: 600,
        positionFromTop: 50,
        resizeDuration: 700,
        showImageNumberLabel: !0,
        wrapAround: !1,
        disableScrolling: !1,
        sanitizeTitle: !1
    }, b.prototype.option = function (b) {
        a.extend(this.options, b)
    }, b.prototype.imageCountLabel = function (a, b) {
        return this.options.albumLabel.replace(/%1/g, a).replace(/%2/g, b)
    }, b.prototype.init = function () {
        var b = this;
        a(document).ready(function () {
            b.enable(), b.build()
        })
    }, b.prototype.enable = function () {
        var b = this;
        a("body").on("click", "a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]", function (c) {
            return b.start(a(c.currentTarget)), !1
        })
    }, b.prototype.build = function () {
        if (!(a("#lightbox").length > 0)) {
            var b = this;
            a('<div id="lightboxOverlay" class="lightboxOverlay"></div><div id="lightbox" class="lightbox"><div class="lb-outerContainer"><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" /><div class="lb-nav"><a class="lb-prev" href="" ></a><a class="lb-next" href="" ></a></div><div class="lb-loader"><a class="lb-cancel"></a></div></div></div><div class="lb-dataContainer"><div class="lb-data"><div class="lb-details"><span class="lb-caption"></span><span class="lb-number"></span></div><div class="lb-closeContainer"><a class="lb-close"></a></div></div></div></div>').appendTo(a("body")), this.$lightbox = a("#lightbox"), this.$overlay = a("#lightboxOverlay"), this.$outerContainer = this.$lightbox.find(".lb-outerContainer"), this.$container = this.$lightbox.find(".lb-container"), this.$image = this.$lightbox.find(".lb-image"), this.$nav = this.$lightbox.find(".lb-nav"), this.containerPadding = {
                top: parseInt(this.$container.css("padding-top"), 10),
                right: parseInt(this.$container.css("padding-right"), 10),
                bottom: parseInt(this.$container.css("padding-bottom"), 10),
                left: parseInt(this.$container.css("padding-left"), 10)
            }, this.imageBorderWidth = {
                top: parseInt(this.$image.css("border-top-width"), 10),
                right: parseInt(this.$image.css("border-right-width"), 10),
                bottom: parseInt(this.$image.css("border-bottom-width"), 10),
                left: parseInt(this.$image.css("border-left-width"), 10)
            }, this.$overlay.hide().on("click", function () {
                return b.end(), !1
            }), this.$lightbox.hide().on("click", function (c) {
                return "lightbox" === a(c.target).attr("id") && b.end(), !1
            }), this.$outerContainer.on("click", function (c) {
                return "lightbox" === a(c.target).attr("id") && b.end(), !1
            }), this.$lightbox.find(".lb-prev").on("click", function () {
                return 0 === b.currentImageIndex ? b.changeImage(b.album.length - 1) : b.changeImage(b.currentImageIndex - 1), !1
            }), this.$lightbox.find(".lb-next").on("click", function () {
                return b.currentImageIndex === b.album.length - 1 ? b.changeImage(0) : b.changeImage(b.currentImageIndex + 1), !1
            }), this.$nav.on("mousedown", function (a) {
                3 === a.which && (b.$nav.css("pointer-events", "none"), b.$lightbox.one("contextmenu", function () {
                    setTimeout(function () {
                        this.$nav.css("pointer-events", "auto")
                    }.bind(b), 0)
                }))
            }), this.$lightbox.find(".lb-loader, .lb-close").on("click", function () {
                return b.end(), !1
            })
        }
    }, b.prototype.start = function (b) {
        function c(a) {
            d.album.push({
                alt: a.attr("data-alt"),
                link: a.attr("href"),
                title: a.attr("data-title") || a.attr("title")
            })
        }

        var d = this, e = a(window);
        e.on("resize", a.proxy(this.sizeOverlay, this)), a("select, object, embed").css({visibility: "hidden"}), this.sizeOverlay(), this.album = [];
        var f, g = 0, h = b.attr("data-lightbox");
        if (h) {
            f = a(b.prop("tagName") + '[data-lightbox="' + h + '"]');
            for (var i = 0; i < f.length; i = ++i) c(a(f[i])), f[i] === b[0] && (g = i)
        } else if ("lightbox" === b.attr("rel")) c(b); else {
            f = a(b.prop("tagName") + '[rel="' + b.attr("rel") + '"]');
            for (var j = 0; j < f.length; j = ++j) c(a(f[j])), f[j] === b[0] && (g = j)
        }
        var k = e.scrollTop() + this.options.positionFromTop, l = e.scrollLeft();
        this.$lightbox.css({
            top: k + "px",
            left: l + "px"
        }).fadeIn(this.options.fadeDuration), this.options.disableScrolling && a("html").addClass("lb-disable-scrolling"), this.changeImage(g)
    }, b.prototype.changeImage = function (b) {
        var c = this;
        this.disableKeyboardNav();
        var d = this.$lightbox.find(".lb-image");
        this.$overlay.fadeIn(this.options.fadeDuration), a(".lb-loader").fadeIn("slow"), this.$lightbox.find(".lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-numbers, .lb-caption").hide(), this.$outerContainer.addClass("animating");
        var e = new Image;
        e.onload = function () {
            var f, g, h, i, j, k;
            d.attr({
                alt: c.album[b].alt,
                src: c.album[b].link
            }), a(e), d.width(e.width), d.height(e.height), c.options.fitImagesInViewport && (k = a(window).width(), j = a(window).height(), i = k - c.containerPadding.left - c.containerPadding.right - c.imageBorderWidth.left - c.imageBorderWidth.right - 20, h = j - c.containerPadding.top - c.containerPadding.bottom - c.imageBorderWidth.top - c.imageBorderWidth.bottom - 120, c.options.maxWidth && c.options.maxWidth < i && (i = c.options.maxWidth), c.options.maxHeight && c.options.maxHeight < i && (h = c.options.maxHeight), (e.width > i || e.height > h) && (e.width / i > e.height / h ? (g = i, f = parseInt(e.height / (e.width / g), 10), d.width(g), d.height(f)) : (f = h, g = parseInt(e.width / (e.height / f), 10), d.width(g), d.height(f)))), c.sizeContainer(d.width(), d.height())
        }, e.src = this.album[b].link, this.currentImageIndex = b
    }, b.prototype.sizeOverlay = function () {
        this.$overlay.width(a(document).width()).height(a(document).height())
    }, b.prototype.sizeContainer = function (a, b) {
        function c() {
            d.$lightbox.find(".lb-dataContainer").width(g), d.$lightbox.find(".lb-prevLink").height(h), d.$lightbox.find(".lb-nextLink").height(h), d.showImage()
        }

        var d = this, e = this.$outerContainer.outerWidth(), f = this.$outerContainer.outerHeight(),
            g = a + this.containerPadding.left + this.containerPadding.right + this.imageBorderWidth.left + this.imageBorderWidth.right,
            h = b + this.containerPadding.top + this.containerPadding.bottom + this.imageBorderWidth.top + this.imageBorderWidth.bottom;
        e !== g || f !== h ? this.$outerContainer.animate({
            width: g,
            height: h
        }, this.options.resizeDuration, "swing", function () {
            c()
        }) : c()
    }, b.prototype.showImage = function () {
        this.$lightbox.find(".lb-loader").stop(!0).hide(), this.$lightbox.find(".lb-image").fadeIn(this.options.imageFadeDuration), this.updateNav(), this.updateDetails(), this.preloadNeighboringImages(), this.enableKeyboardNav()
    }, b.prototype.updateNav = function () {
        var a = !1;
        try {
            document.createEvent("TouchEvent"), a = !!this.options.alwaysShowNavOnTouchDevices
        } catch (a) {
        }
        this.$lightbox.find(".lb-nav").show(), this.album.length > 1 && (this.options.wrapAround ? (a && this.$lightbox.find(".lb-prev, .lb-next").css("opacity", "1"), this.$lightbox.find(".lb-prev, .lb-next").show()) : (this.currentImageIndex > 0 && (this.$lightbox.find(".lb-prev").show(), a && this.$lightbox.find(".lb-prev").css("opacity", "1")), this.currentImageIndex < this.album.length - 1 && (this.$lightbox.find(".lb-next").show(), a && this.$lightbox.find(".lb-next").css("opacity", "1"))))
    }, b.prototype.updateDetails = function () {
        var b = this;
        if (void 0 !== this.album[this.currentImageIndex].title && "" !== this.album[this.currentImageIndex].title) {
            var c = this.$lightbox.find(".lb-caption");
            this.options.sanitizeTitle ? c.text(this.album[this.currentImageIndex].title) : c.html(this.album[this.currentImageIndex].title), c.fadeIn("fast").find("a").on("click", function (b) {
                void 0 !== a(this).attr("target") ? window.open(a(this).attr("href"), a(this).attr("target")) : location.href = a(this).attr("href")
            })
        }
        if (this.album.length > 1 && this.options.showImageNumberLabel) {
            var d = this.imageCountLabel(this.currentImageIndex + 1, this.album.length);
            this.$lightbox.find(".lb-number").text(d).fadeIn("fast")
        } else this.$lightbox.find(".lb-number").hide();
        this.$outerContainer.removeClass("animating"), this.$lightbox.find(".lb-dataContainer").fadeIn(this.options.resizeDuration, function () {
            return b.sizeOverlay()
        })
    }, b.prototype.preloadNeighboringImages = function () {
        if (this.album.length > this.currentImageIndex + 1) {
            (new Image).src = this.album[this.currentImageIndex + 1].link
        }
        if (this.currentImageIndex > 0) {
            (new Image).src = this.album[this.currentImageIndex - 1].link
        }
    }, b.prototype.enableKeyboardNav = function () {
        a(document).on("keyup.keyboard", a.proxy(this.keyboardAction, this))
    }, b.prototype.disableKeyboardNav = function () {
        a(document).off(".keyboard")
    }, b.prototype.keyboardAction = function (a) {
        var b = a.keyCode, c = String.fromCharCode(b).toLowerCase();
        27 === b || c.match(/x|o|c/) ? this.end() : "p" === c || 37 === b ? 0 !== this.currentImageIndex ? this.changeImage(this.currentImageIndex - 1) : this.options.wrapAround && this.album.length > 1 && this.changeImage(this.album.length - 1) : "n" !== c && 39 !== b || (this.currentImageIndex !== this.album.length - 1 ? this.changeImage(this.currentImageIndex + 1) : this.options.wrapAround && this.album.length > 1 && this.changeImage(0))
    }, b.prototype.end = function () {
        this.disableKeyboardNav(), a(window).off("resize", this.sizeOverlay), this.$lightbox.fadeOut(this.options.fadeDuration), this.$overlay.fadeOut(this.options.fadeDuration), a("select, object, embed").css({visibility: "visible"}), this.options.disableScrolling && a("html").removeClass("lb-disable-scrolling")
    }, new b
});
//# sourceMappingURL=lightbox.min.map


/* Scroller Tab */
"use strict"
var touch_device = "ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch || navigator.maxTouchPoints > 0,
    $_document = $(document), $_window = $(window)
$.fn.swipe = function (t) {
    return t = $.extend({left: null, right: null}, t), this.each(function () {
        if (t.left || t.right) {
            var e = 0, i = 0, a = 0, n = 0, o = !1
            $(this).on("touchstart", function (t) {
                e = t.pageX || t.touches[0].pageX, i = t.pageY || t.touches[0].pageY
            }), $(this).on("touchmove", function (t) {
                return !(!1 === o && (a = e - (t.pageX || t.touches[0].pageX), n = i - (t.pageY || t.touches[0].pageY), Math.abs(a) > 10 && Math.abs(n) < 10)) || (o = a > 0 ? "left" : "right", !1)
            }), $_window.on("touchend", function (e) {
                o && t[o] && t[o](), a = 0, n = 0, o = !1
            })
        }
    })
}, $_document.on("DOMContentLoaded", function () {
    var t, e, i, a, n, o, s, d, c, l, r, h, u, f, p, v, g, m, w, _, y = $("body"), C = $("html, body")
    touch_device && y.addClass("touch-device"), t = $("#header"), i = (e = t.find("nav")).find("ul.nav-primary"), a = t.find(".container"), n = t.hasClass("header-static"), o = t.hasClass("header-dynamic"), s = t.hasClass("header-nav-overlay"), o && new Headroom(t[0], {
        offset: 120,
        tolerance: {up: 5}
    }).init(), t.hasClass("header-shadow-scroll") && (d = function () {
        t[0 === $_window.scrollTop() ? "removeClass" : "addClass"]("active")
    }, $_window.on("scroll", d), d()), i.find("li").each(function () {
        if ($(this).has("ul").length) {
            var t = $(this), e = t.find("ul:first")
            t.on("mouseenter", function () {
                e.outerWidth() + e.offset().left + 20 - a.offset().left > a.width() && e.addClass("nav-left")
            }).on("mouseleave", function () {
                e.removeClass("nav-left")
            }), t.find("> .button").length ? e.addClass("nav-button").css("minWidth", t.outerWidth() - 20 + "px") : e.css("minWidth", t.outerWidth() + 20 + "px")
        }
        $(this).find("a.button").length && $(this).next().find("a.button").length && $(this).addClass("button-follows")
    }), e.length && (c = $('<div id="nav-overlay-background"></div>'), l = $('<i id="nav-overlay-open" class="material-icons">menu</i>'), r = $('<i id="nav-overlay-close" class="material-icons">close</i>'), h = $('<div id="nav-overlay"></div>').append(a.clone().append(r)), u = (t.hasClass("header-light") ? "light" : t.hasClass("header-gray") && "gray") || t.hasClass("header-dark") && "dark", (f = $.trim((s ? "nav-overlay-visible" : "") + " " + (u ? "nav-overlay-" + u : ""))) && (h.addClass(f), l.addClass(f), r.addClass(f), c.addClass(f)), l.appendTo(a).on("click", function () {
        y.prepend(c, h), $_window.scrollTop(0)
    }), r.on("click", function () {
        c.detach(), h.detach()
    })), p = $("#notification").show(), (v = p.data()) && v.dismissible && (v.title && Cookies.get("notification-" + v.title) ? p.remove() : (s && p.addClass("notification-dismiss-align"), $('<i id="notification-dismiss" class="material-icons">close</i>').prependTo(p.find("div.container")).on("click", function () {
        p.addClass("notification-hide"), v.title && Cookies.set("notification-" + v.title, 0, {expires: $.isNumeric(v.expires) ? v.expires : ""})
    }))), $("span.type-text").each(function () {
        var t, e = $(this), i = $.trim(e.text()), a = e.data("type-text"), n = 1e3 * (e.data("type-text-speed") || .1),
            o = 1e3 * (e.data("type-text-delay") || 2), s = !!e.data("type-text-loop"), d = 0, c = 0, l = 0, r = !1,
            h = !1
        a && (a = a.split(";"), $.map(a, $.trim), i && (a.unshift(i), l = a[c].length, r = !0), (d = a.length) && (t = function () {
            (l < a[c].length || r) && setTimeout(function () {
                h = !1, l += r ? -1 : 1, e.text(a[c].substr(0, l)), (c < d - 1 || s) && (r && 0 === l ? (c = c === d - 1 && s ? 0 : c + 1, r = !1) : l === a[c].length && (r = !0, h = !0)), setTimeout(t, h ? o : 0)
            }, r ? n / 2 : n)
        }, setTimeout(t, i ? o : 0)))
    }), $('form input[type="checkbox"]:not(.no-custom-style), form input[type="radio"]:not(.no-custom-style)').each(function () {
        var t = $(this), e = t.attr("type"), i = t.closest("div.form-row"),
            a = $('<div class="' + e + '-style"></div>'),
            n = $("checkbox" === e ? '<i class="fa fa-check"></i>' : '<div class="radio-style-icon"></div>'),
            o = "checkbox" === e ? t : t.closest("form").find('input[name="' + t.attr("name") + '"]')
        n.on("click", function () {
            !1 === t.is(":disabled") && (t.filter(':not([type="radio"]:checked)').prop("checked", !1 === t.is(":checked")), o.trigger("change"))
        }), o.on("change", function () {
            a[t.is(":checked") ? "addClass" : "removeClass"]("active")
        }), t.closest("form").on("reset", function () {
            setTimeout(function () {
                o.trigger("change")
            }, 10)
        }), t.on("focus blur", function (t) {
            a["focus" === t.type ? "addClass" : "removeClass"]("focus")
        }), 1 === i.find('input[type="' + e + '"]').length && i.addClass(e + "-style-block"), t.is(":disabled") && a.addClass("disabled"), t.is(":checked") && a.addClass("active"), t.after(a.append(n)), a.append(t)
    }), $("form select:not([multiple]):not(.no-custom-style)").each(function () {
        var t = $(this), e = $('<input type="text">'), i = $('<div class="select-style"></div>'),
            a = $('<i class="fa fa-chevron-down"></i>')
        t.on("change", function () {
            e.val(t.find("option:selected").text())
        }), t.on("focus blur", function (t) {
            e["focus" === t.type ? "addClass" : "removeClass"]("focus")
        }), t.closest("form").on("reset", function () {
            setTimeout(function () {
                t.trigger("change")
            }, 10)
        }), e.on("focus", function () {
            t.trigger("focus")
        }), e.val(t.find("option:selected").text()), e.attr(t.is(":disabled") ? "disabled" : "readonly", !0), t.after(i.append(a, e)), i.append(t)
    }), $('form input[type="search"]:not(.no-custom-style)').each(function () {
        var t = $(this), e = t.closest("form"), i = $('<div class="search-style"></div>'),
            a = $('<i class="fa fa-search"></i>')
        a.on("click", function () {
            e.submit()
        }), t.after(i.append(a)), i.append(t)
    }), $("div.tab-group").each(function () {
        var t = $(this), e = $("<ul></ul>"), i = t.find("div.tab-item"),
            a = Math.max(0, i.filter(location.hash && i.filter(location.hash).length ? location.hash : ".active").index())
        i.length > 1 && (i.each(function (n) {
            var o = $(this), s = $("<li></li>"), d = $('<div class="tab-item-title"></div>'),
                c = $('<div class="tab-item-inner"></div>'), l = o.data("title") || n, r = o.attr("id"),
                h = function () {
                    r && history.pushState(null, null, "#" + r), t.find("div.tab-title").removeClass("active"), e.find("li").removeClass("active"), i.removeClass("active"), d.addClass("active"), s.addClass("active"), o.addClass("active")
                }
            n === a && (d.addClass("active"), s.addClass("active"), o.addClass("active")), r && (o.removeAttr("id"), t.prepend('<a id="' + r + '"></a>'), $_window.on("hashchange", function () {
                location.hash.substr(1) === r && h()
            })), d.text(l).on("click", h).prependTo(o.wrapInner(c)), s.text(l).on("click", h).appendTo(e)
        }), t.prepend(e))
    }), $("div.gallery").each(function (t) {
        var e, i, a, n, o, s, d, c, l = $(this), r = l.find("ul"), h = r.find("li a"), u = r.find("li img")
        h.length > 0 && h.on("click", function (e) {
            var i, a, n, o, s, d, c, l, r, u, f, p, v, g = $(this).attr("href")
            $.inArray(g.split(".").pop(), ["jpg", "jpeg", "png", "gif"]) > -1 && (i = $('<div id="gallery-overlay"></div>'), a = $('<i id="gallery-overlay-close" class="material-icons">close</i>'), n = $('<i id="gallery-overlay-previous" class="material-icons">chevron_left</i>'), o = $('<i id="gallery-overlay-next" class="material-icons">chevron_right</i>'), s = $('<p id="gallery-overlay-title" class="hide"></p>'), d = $("<ul></ul>"), c = null, l = 0, r = 0, u = function (t) {
                27 === t.keyCode ? a.click() : 37 === t.keyCode ? n.click() : 39 === t.keyCode && o.click()
            }, h.each(function (e) {
                var i, a, n, o = $(this).attr("href"), c = $(this).attr("title")
                $.inArray(o.split(".").pop(), ["jpg", "jpeg", "png", "gif"]) > -1 && (i = $('<div class="loading hide"></div>'), a = $('<img id="gallery-overlay-' + t + "-" + r++ + '">'), g === o ? (n = setTimeout(function () {
                    i.removeClass("hide")
                }, 50), a.attr("src", o).imagesLoaded(function () {
                    n && clearTimeout(n), i.addClass("hide"), a.addClass("ready")
                }), c && s.text(c).removeClass("hide"), l = e) : a.data("src", o), c && a.data("title", c), d.append($("<li></li>").append(i, a)))
            }), (c = d.find("li")).each(function (t) {
                $(this).css({width: 100 / c.length + "%", left: 100 / c.length * t + "%"})
            }), $_window.on("keydown", u), y.prepend(i.append(d)), i.append(a, s), d.css("width", 100 * c.length + "%"), a.on("click", function () {
                $_window.off("keydown", u), i.remove()
            }), c.length > 1 && (f = function (e) {
                var i, a = $("#gallery-overlay-" + t + "-" + e), l = a.parent().find("div.loading"), r = a.data("src"),
                    h = a.data("title")
                r && (i = setTimeout(function () {
                    l.removeClass("hide")
                }, 50), a.data("src", "").attr("src", r).imagesLoaded(function () {
                    i && clearTimeout(i), l.addClass("hide"), a.addClass("ready")
                })), h ? s.text(h).removeClass("hide") : s.addClass("hide"), n[0 === e ? "hide" : "show"](), o[e + 1 === c.length ? "hide" : "show"](), d.css("transform", "translateX(-" + 100 / c.length * e + "%)")
            }, p = function () {
                l - 1 > -1 && f(l -= 1)
            }, v = function () {
                l + 1 < c.length && f(l += 1)
            }, l > 0 ? f(l) : n.hide(), touch_device && i.swipe({
                left: v,
                right: p
            }), i.append(n, o), n.on("click", p), o.on("click", v)), e.preventDefault())
        }), u.length > 1 && l.is(".gallery-slider") && (e = $('<i class="gallery-previous material-icons">chevron_left</i>'), i = $('<i class="gallery-next material-icons">chevron_right</i>'), a = $(this).data("rotation"), n = 0, o = function (t, e) {
            t.imagesLoaded(function () {
                l[e ? "addClass" : "removeClass"]("gallery-animate").css("height", t.height() + "px")
            })
        }, s = function (e, i, n) {
            n && a && clearInterval(a), o($("#gallery-" + t + "-" + i), !0), r.css("transform", "translateX(-" + 100 / u.length * i + "%)")
        }, d = function () {
            s(n, n = n - 1 < 0 ? u.length - 1 : n - 1, !0)
        }, c = function () {
            s(n, n = n + 1 > u.length - 1 ? 0 : n + 1, !0)
        }, u.each(function (e) {
            0 === e && $_window.on("load", function () {
                o($("#gallery-" + t + "-" + e), !1)
            }), $(this).attr("id", "gallery-" + t + "-" + e)
        }), touch_device && l.swipe({
            left: c,
            right: d
        }), e.on("click", d), i.on("click", c), $_window.on("resize", function () {
            o($("#gallery-" + t + "-" + n), !1)
        }), r.css("width", 100 * u.length + "%"), l.prepend(e, i), a && (a = setInterval(function () {
            s(n, n = n + 1 > u.length - 1 ? 0 : n + 1, !1)
        }, 1e3 * a)))
    }), $("select.product-term-select").each(function (t) {
        var e = $(this), i = $('select.product-term-select[data-sync="' + e.data("sync") + '"]'),
            a = e.parents("div.product-box"), n = a.find("div.product-order a.button"), o = a.find("div.product-price"),
            s = function (t) {
                if (!1 === e.is(":disabled")) {
                    var a = e.find("option:selected"), s = a.data("price"), d = a.data("term"), c = a.data("href")
                    c && n.length && n.attr("href", c), s && o.length && (o.html(s), d && o.append('<span class="term">' + d + "</span>")), i.length && t && t.originalEvent && i.find("option:eq(" + a.index() + ")").prop("selected", !0).change()
                }
            }
        e.on("change", s), s()
    }), $("div.product-slider").each(function (t) {
        var e, i, a, n, o, s, d = $(this), c = d.find("> ul"),
            l = (c.first().find("li").length, c.filter(".active").length)
        c.length > 0 && (e = 100 / c.length, i = $('div.product-slider[data-sync="' + d.data("sync") + '"]'), a = $('<div class="slider clear"></div>'), n = $('<div class="handle"></div>'), o = $('<div class="range"></div>'), s = function (n, s) {
            var d = (n - a.offset().left) / a.width() * 100, l = Math.min(Math.max(d / (100 / c.length), 1), c.length),
                r = Math.round(l)
            Math.abs(r - l) < .1 || s ? i.length ? i.each(function () {
                $(this).find("> ul").removeClass("active"), $(this).find("div.range").css("width", e * r + "%"), $("#" + $(this).attr("id") + "-" + (r - 1)).addClass("active")
            }) : (c.removeClass("active"), o.css("width", e * r + "%"), $("#product-slider-" + t + "-" + (r - 1)).addClass("active")) : o.css("width", d + "%")
        }, c.each(function (i) {
            (0 === l && 0 === i || 1 === l && $(this).is(".active")) && ($(this).addClass("active"), o.css("width", e * (i + 1) + "%").append(n)), $(this).attr("id", "product-slider-" + t + "-" + i), a.append('<div class="segment" style="width: ' + e + '%;"></div>')
        }), a.on("click", function (t) {
            s(t.pageX, !0)
        }), n.on("mousedown touchstart", function (t) {
            $_window.on("mousemove touchmove", function (t) {
                s(t.pageX || t.touches[0].pageX, !1)
            }), $_window.on("mouseup touchend", function (t) {
                s(t.pageX || t.changedTouches[0].pageX, !0), $_window.off("mousemove touchmove").off("mouseup touchend")
            }), t.preventDefault()
        }), d.attr("id", "product-slider-" + t), d.prepend(a.prepend(o)))
    }), $("div.product-configurator").each(function (t) {
        var e = $(this), i = $('div.product-configurator[data-sync="' + e.data("sync") + '"]'),
            a = e.find("div.configurator-total span.value"), n = e.find("div.configurator-row input"),
            o = e.data("currency")
        e.length && n.length && o && n.each(function (t) {
            var e, s, d, c = $(this), l = $('<div class="configurator-group"></div>'),
                r = $('<div class="slider clear"></div>'), h = $('<div class="handle"></div>'),
                u = $('<div class="range"></div>'), f = $('<span class="value"></span>'), p = Number(c.val()),
                v = Number(c.data("min")), g = Number(c.data("max")), m = (Number(c.data("price")), c.data("title")),
                w = c.data("title-plural"), _ = c.data("description"), y = g / v, C = 100 / y
            if (y === parseInt(y, 10)) {
                for (e = function (t) {
                    if (t.el_configurator_title.length && (t.val_configurator_input = t.val_configurator_input + (t.val_configurator_title_plural && 1 != t.val_configurator_input ? t.val_configurator_title_plural : t.val_configurator_title), t.el_configurator_title.html(t.val_configurator_input)), t.el_product_configurator_total.length) {
                        var e = 0
                        t.el_product_configurator_input.each(function () {
                            var t = Number($(this).val()), i = Number($(this).data("min")),
                                a = Number($(this).data("price"))
                            e += t / i * a
                        }), t.el_product_configurator_total.html(t.val_product_configurator_currency.replace("%", Math.round(e * Math.pow(10, 4)) / Math.pow(10, 4)))
                    }
                }, s = function (t, s) {
                    var d = (t - r.offset().left) / r.width() * 100, l = Math.min(Math.max(d / (100 / y), 1), y),
                        h = Math.round(l), p = Math.abs(h - l), g = v * h;
                    (p < .1 || s) && (i.length ? i.each(function () {
                        var t = $(this), i = t.find("div.configurator-total span.value"),
                            a = t.find("div.configurator-row input"), n = a.filter('[name="' + c.attr("name") + '"]'),
                            o = n.parents("div.configurator-row")
                        o.find("div.range").css("width", C * h + "%"), n.val(g), e({
                            el_configurator_title: o.find("div.configurator-group span.value"),
                            el_product_configurator_total: i,
                            el_product_configurator_input: a,
                            val_configurator_input: g,
                            val_configurator_title: n.data("title"),
                            val_configurator_title_plural: n.data("title-plural"),
                            val_product_configurator_currency: t.data("currency")
                        })
                    }) : (u.css("width", C * h + "%"), c.val(g), e({
                        el_configurator_title: f,
                        el_product_configurator_total: a,
                        el_product_configurator_input: n,
                        val_configurator_input: g,
                        val_configurator_title: m,
                        val_configurator_title_plural: w,
                        val_product_configurator_currency: o
                    })))
                }, d = 0; d < y; d++) p == (d + 1) * v && u.css("width", C * (d + 1) + "%").append(h), r.append('<div class="segment" style="width: ' + C + '%;"></div>')
                r.on("click", function (t) {
                    s(t.pageX, !0)
                }), h.on("mousedown touchstart", function (t) {
                    $_window.on("mousemove touchmove", function (t) {
                        s(t.pageX || t.touches[0].pageX, !1)
                    }), $_window.on("mouseup touchend", function (t) {
                        s(t.pageX || t.changedTouches[0].pageX, !0), $_window.off("mousemove touchmove").off("mouseup touchend")
                    }), t.preventDefault()
                }), c.before(l.html(f).append(_ ? '<span class="label">' + _ + "</span>" : "")), c.before(r.prepend(u)), e({
                    el_configurator_title: f,
                    el_product_configurator_total: a,
                    el_product_configurator_input: n,
                    val_configurator_input: p,
                    val_configurator_title: m,
                    val_configurator_title_plural: w,
                    val_product_configurator_currency: o
                })
            }
        })
    }), $("pre.pre-code").each(function () {
        var t, e = $("<ul></ul>"), i = $(this).html().trim("\n"), a = i.split("\n").length
        if (a) {
            for (t = 1; t <= a; t++) e.append("<li>" + t + "</li>")
            $(this).removeClass("pre-code").wrap('<div class="pre-code"></div>').after(e)
        }
    }), $("iframe.iframe-keep-aspect-ratio").each(function () {
        var t = $(this), e = $(this).attr("width"), i = $(this).attr("height"), a = function () {
            var a = t.width(), n = 0
            e !== a && (n = Math.round(i / e * a), t.css("height", n + "px"))
        }
        $_window.on("resize", a), a()
    }), $("table").each(function () {
        if (!1 === $(this).is(".table-layout-static")) {
            var t = $(this).find("thead tr th"), e = $(this).find("tbody tr")
            t.length && e.length && t.each(function (t) {
                var i = e.find("td:nth-of-type(" + (t + 1) + ")"), a = $(this).text()
                i.length && a && i.addClass("has-responsive-th").prepend('<span class="responsive-th">' + a + "</span>")
            })
        }
        $(this).has("caption").addClass("table-has-caption")
    }), $("div.grid").each(function () {
        var t, e = $(this), i = e.find("> div.grid-item"), a = e.closest("div.container"), n = e.data("grid-columns"),
            o = e.data("grid-gap")
        i.length && (n = n || 3, o = o >= 0 ? o : 60, t = function () {
            var t = a.outerWidth(), s = n, d = o, c = $_window.width()
            $.each([512, 768, 1024], function (t, e) {
                if (c <= e) return s = Math.max(n - (3 - t), 1), d = Math.min(o, 30), !1
            }), i.css("width", ((t - d * (s - 1)) / s).toFixed(4) + "px"), Bricks({
                container: e[0],
                packed: "data-grid",
                sizes: [{columns: s, gutter: d}]
            }).pack()
        }, $_window.on("resize", t), $_window.on("load", t), t())
    }), $("section.content-row").each(function () {
        var e, i, a, n, s = $(this), d = s.hasClass("content-row-half-height"),
            c = s.hasClass("content-row-full-height");
        (d || c) && (e = 0, i = c ? 1 : 2, a = s.is("section.content-row:first"), n = function () {
            s.css("height", "auto"), (e = Math.round(($_window.height() - (a ? s.offset().top : o ? 0 : t.outerHeight())) / i)) > s.outerHeight() && s.css("height", e + "px")
        }, $_window.on("resize", n), $_window.on("load", n), n())
    }), $("div.content-slider").each(function (t) {
        var e, i, a, n, o, s, d, c, l, r, h = $(this), u = h.find("> .slide"),
            f = $('<div class="content-slider-inner"></div>'), p = u.length
        p && (e = function () {
            var t = 0, e = parseInt(u.css("padding-top"), 10), i = parseInt(u.css("padding-bottom"), 10)
            u.find("div.container").each(function () {
                t = Math.max(t, $(this).outerHeight())
            }), h.css("height", t + e + i + "px")
        }, p > 1 ? (i = 0, a = h.data("nav"), n = h.data("rotation"), o = $("<ul></ul>"), null, s = function (e, i, o) {
            o && n && clearInterval(n), a && ($("#content-slider-nav-" + t + "-" + e).removeClass("active"), $("#content-slider-nav-" + t + "-" + i).addClass("active")), e > i ? ($("#content-slider-" + t + "-" + e).addClass("inactive animate-previous").removeClass("active"), $("#content-slider-" + t + "-" + i).addClass("active animate-previous").removeClass("inactive")) : ($("#content-slider-" + t + "-" + e).addClass("inactive").removeClass("active animate-previous"), $("#content-slider-" + t + "-" + i).addClass("active").removeClass("inactive animate-previous"))
        }, d = function () {
            s(i, i = i - 1 < 0 ? p - 1 : i - 1, !0)
        }, c = function () {
            s(i, i = i + 1 > p - 1 ? 0 : i + 1, !0)
        }, -1 === (i = h.find(".slide.active").index()) && (i = 0), u.each(function (e) {
            if (a) {
                var n = $("<li></li>"), s = $(this).data("title"), d = null
                e === i && n.addClass("active"), s && (d = function () {
                    n.text($_window.width() <= 768 ? "" : s)
                }, $_window.on("resize", d), d()), n.attr("id", "content-slider-nav-" + t + "-" + e).data("slide", e), o.append(n)
            }
            e === i && $(this).removeClass("active").addClass("active-first"), $(this).attr("id", "content-slider-" + t + "-" + e)
        }), a && (h.addClass("content-slider-has-nav").prepend(o), o.find("li").on("click", function () {
            s(i, i = $(this).data("slide"), !0)
        })), h.data("nav-directional") && (l = $('<i class="slide-previous material-icons">chevron_left</i>'), r = $('<i class="slide-next material-icons">chevron_right</i>'), h.prepend(l, r), l.on("click", d), r.on("click", c)), touch_device && h.swipe({
            left: c,
            right: d
        }), n && (n = setInterval(function () {
            s(i, i = i + 1 > p - 1 ? 0 : i + 1, !1)
        }, 1e3 * n))) : u.removeClass("active").addClass("active-first"), h.append(f.append(u)), $_window.on("resize", e), $_window.on("load", e), e())
    }), $("div.content-background").each(function () {
        var t, e, i, a, n, o, s = $(this), d = s.find("i, img, video, iframe")
        d.length && (t = d.is("i"), e = d.is("img, video"), i = s.hasClass("content-background-scale"), a = s.hasClass("content-background-scroll"), t ? (t = function () {
            var t = s.outerWidth(), e = s.outerHeight()
            d.css("font-size", Math.round(Math[i ? "min" : "max"](t, e)) + "px")
        }, $_window.on("resize", t), $_window.on("load", t), t()) : e && (e = function () {
            s.removeClass("object-fit-width"), s.removeClass("object-fit-height"), i ? (s.outerWidth() < d.outerWidth() && s.addClass("object-fit-width"), s.outerHeight() < d.outerHeight() && s.addClass("object-fit-height")) : s.outerHeight() > d.outerHeight() && s.addClass("object-fit-height")
        }, d.on("loadeddata", e), $_window.on("resize", e), $_window.on("load", e), e()), a && (n = s.closest("section.content-row"), o = null, a = function () {
            var t = n.offset().top, e = n.outerHeight(), i = $_window.scrollTop(), a = $_window.height()
            i + a > t && i < t + e && s.css("transform", "translate3d(0, " + (40 * ((i + a - t) / (e + a)).toFixed(4) - 20) + "%, 0)")
        }, window.requestAnimationFrame && (o = function () {
            requestAnimationFrame(a)
        }), $_window.on("resize scroll", o || a), $_window.on("load", a), a()))
    }), $("a.video-overlay").each(function () {
        var t, e, i, a = $(this), n = a.attr("href")
        n && (t = n.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/), e = n.match(/(?:https?:\/{2})?(?:w{3}\.)?vimeo\.com\/(\d+)(?:$|[^\s&]+)/), i = $.inArray(n.split(".").pop(), ["mp4", "mov"]) > -1, (t || e || i) && (a.find("> img").length && (a.addClass("video-overlay-has-icon"), a.append('<i id="video-overlay-icon" class="material-icons">play_arrow</i>')), t = !!t && "https://www.youtube.com/embed/" + t[1] + "?autoplay=1", e = !!e && "https://player.vimeo.com/video/" + e[1] + "?autoplay=1", i = !!i && n, a.on("click", function (a) {
            var n = $('<div id="video-overlay"></div>'),
                o = $('<i id="video-overlay-close" class="material-icons">close</i>'),
                s = $(i ? "<video controls autoplay></video>" : "<iframe allowfullscreen></iframe>"), d = function (t) {
                    27 === t.keyCode && o.click()
                }, c = function () {
                    var t = Math.min(($_window.width() - 120) / 1280, ($_window.height() - 120) / 720)
                    s.css({width: Math.round(1280 * t) + "px", height: Math.round(720 * t) + "px"})
                }
            n.append(s.attr("src", i || (t || e))), y.prepend(n.append(o)), $_window.on("keydown", d), $_window.on("resize", c), o.on("click", function () {
                $_window.off("keydown", d), $_window.off("resize", c), n.remove()
            }), c(), a.preventDefault()
        })))
    })
})
